module.exports = __webpack_public_path__ + "img/egg_left.2c30d099.png";